import React from "react";
import { AuthRoutes } from "./authRoutes";
import { useGlobal } from "../hooks/global";

export const Routes: React.FC = () => {
    const { clickOnApp } = useGlobal()

    return (
        <div onClick={clickOnApp} style={{ display: "flex", flex: 1 }}>
            <AuthRoutes />
        </div>
    )
}
